import {
    CategorieDArticleJsonldCategorieArticleAll,
    CategorieDArticleJsonldCategorieArticleCreate,
} from '@europrocurement/l2d-domain/openApi/ApiOffre';
import { castIriToId } from '@europrocurement/l2d-utils';
import { ArticleCategorySchema } from './schema';

/** API -> Form -> API Serialization */

export const input: (
    entity?: CategorieDArticleJsonldCategorieArticleAll,
) => ArticleCategorySchema = (entity = undefined) => {
    const defaultValues: ArticleCategorySchema = {
        libelle: '',
        domainId: null as unknown as number,
    };

    if (!entity) {
        return defaultValues;
    }

    const domaineId = entity.domaine ? Number(castIriToId(entity.domaine)) : null;

    return {
        libelle: entity.libelle ?? defaultValues.libelle,
        domainId: domaineId as unknown as number,
    };
};

/** Format request payload to match Api expectations (PUT réutilise le payload Create). */
export const output = (
    formData: ArticleCategorySchema,
    companyId: number,
): CategorieDArticleJsonldCategorieArticleCreate => ({
    libelle: formData.libelle,
    // API Offre accepte un identifiant simple ou une iri pour les relations.
    domaine: formData.domainId as unknown as string,
    societe: companyId as unknown as string,
});
